// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"212":"59549a1e","458":"515a1a9d"}[chunkId] + ".css";
};